// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom scrollbar styles - thin and elegant like in the screenshot */

/* Webkit browsers (Chrome, Safari, Edge) */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #2a2a2a;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #666666;
  border-radius: 50%;
  border: 1px solid #333333;
}

::-webkit-scrollbar-thumb:hover {
  background: #777777;
}

::-webkit-scrollbar-thumb:active {
  background: #888888;
}

::-webkit-scrollbar-corner {
  background: #2a2a2a;
}

/* Firefox scrollbar styling */
* {
  scrollbar-width: thin;
  scrollbar-color: #666666 #2a2a2a;
}

/* Custom scrollbar for Material-UI components */
.MuiDialog-paper::-webkit-scrollbar,
.MuiDialogContent-root::-webkit-scrollbar,
.MuiDrawer-paper::-webkit-scrollbar,
.MuiPaper-root::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.MuiDialog-paper::-webkit-scrollbar-track,
.MuiDialogContent-root::-webkit-scrollbar-track,
.MuiDrawer-paper::-webkit-scrollbar-track,
.MuiPaper-root::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

.MuiDialog-paper::-webkit-scrollbar-thumb,
.MuiDialogContent-root::-webkit-scrollbar-thumb,
.MuiDrawer-paper::-webkit-scrollbar-thumb,
.MuiPaper-root::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 50%;
}

.MuiDialog-paper::-webkit-scrollbar-thumb:hover,
.MuiDialogContent-root::-webkit-scrollbar-thumb:hover,
.MuiDrawer-paper::-webkit-scrollbar-thumb:hover,
.MuiPaper-root::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.5);
}

/* Light theme adjustments */
.MuiCssBaseline-root::-webkit-scrollbar-track {
  background: #f5f5f5;
}

.MuiCssBaseline-root::-webkit-scrollbar-thumb {
  background: #c1c1c1;
}

.MuiCssBaseline-root::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* DataGrid custom scrollbars */
.MuiDataGrid-root .MuiDataGrid-virtualScroller::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.MuiDataGrid-root .MuiDataGrid-virtualScroller::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

.MuiDataGrid-root .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
}

.MuiDataGrid-root .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/styles/scrollbar.css"],"names":[],"mappings":"AAAA,sEAAsE;;AAEtE,2CAA2C;AAC3C;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA,gDAAgD;AAChD;;;;EAIE,UAAU;EACV,WAAW;AACb;;AAEA;;;;EAIE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;;;;EAIE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":["/* Custom scrollbar styles - thin and elegant like in the screenshot */\r\n\r\n/* Webkit browsers (Chrome, Safari, Edge) */\r\n::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: #2a2a2a;\r\n  border-radius: 4px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: #666666;\r\n  border-radius: 50%;\r\n  border: 1px solid #333333;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: #777777;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:active {\r\n  background: #888888;\r\n}\r\n\r\n::-webkit-scrollbar-corner {\r\n  background: #2a2a2a;\r\n}\r\n\r\n/* Firefox scrollbar styling */\r\n* {\r\n  scrollbar-width: thin;\r\n  scrollbar-color: #666666 #2a2a2a;\r\n}\r\n\r\n/* Custom scrollbar for Material-UI components */\r\n.MuiDialog-paper::-webkit-scrollbar,\r\n.MuiDialogContent-root::-webkit-scrollbar,\r\n.MuiDrawer-paper::-webkit-scrollbar,\r\n.MuiPaper-root::-webkit-scrollbar {\r\n  width: 6px;\r\n  height: 6px;\r\n}\r\n\r\n.MuiDialog-paper::-webkit-scrollbar-track,\r\n.MuiDialogContent-root::-webkit-scrollbar-track,\r\n.MuiDrawer-paper::-webkit-scrollbar-track,\r\n.MuiPaper-root::-webkit-scrollbar-track {\r\n  background: rgba(0, 0, 0, 0.1);\r\n  border-radius: 3px;\r\n}\r\n\r\n.MuiDialog-paper::-webkit-scrollbar-thumb,\r\n.MuiDialogContent-root::-webkit-scrollbar-thumb,\r\n.MuiDrawer-paper::-webkit-scrollbar-thumb,\r\n.MuiPaper-root::-webkit-scrollbar-thumb {\r\n  background: rgba(0, 0, 0, 0.3);\r\n  border-radius: 50%;\r\n}\r\n\r\n.MuiDialog-paper::-webkit-scrollbar-thumb:hover,\r\n.MuiDialogContent-root::-webkit-scrollbar-thumb:hover,\r\n.MuiDrawer-paper::-webkit-scrollbar-thumb:hover,\r\n.MuiPaper-root::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n/* Light theme adjustments */\r\n.MuiCssBaseline-root::-webkit-scrollbar-track {\r\n  background: #f5f5f5;\r\n}\r\n\r\n.MuiCssBaseline-root::-webkit-scrollbar-thumb {\r\n  background: #c1c1c1;\r\n}\r\n\r\n.MuiCssBaseline-root::-webkit-scrollbar-thumb:hover {\r\n  background: #a8a8a8;\r\n}\r\n\r\n/* DataGrid custom scrollbars */\r\n.MuiDataGrid-root .MuiDataGrid-virtualScroller::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n.MuiDataGrid-root .MuiDataGrid-virtualScroller::-webkit-scrollbar-track {\r\n  background: rgba(0, 0, 0, 0.05);\r\n  border-radius: 4px;\r\n}\r\n\r\n.MuiDataGrid-root .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb {\r\n  background: rgba(0, 0, 0, 0.2);\r\n  border-radius: 50%;\r\n}\r\n\r\n.MuiDataGrid-root .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(0, 0, 0, 0.3);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
